module.exports = __webpack_public_path__ + "static/img/20.8e92645.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka3/20.jpg
// module id = IES7
// module chunks = 16